import { combineReducers } from "@reduxjs/toolkit";

// slice 
import authReducer from "./features/slices/authSlice/authSlice";
import ThemeModeReducer from "./features/slices/ThemeModeSlice/ThemeModeSlice";
import  chatSliceReducer  from "./features/slices/chatSlice/chatSlice";


// api 
import { UserAuthorizedApi } from "./services/UserAuthorizedApi/UserAuthorizedApi";
import { UserAuthApi } from "./services/UserAuthApi/UserAuthApi";
import { ChatApi } from "./services/ChatApi/ChatApi";



export const rootReducers = combineReducers({
  auth: authReducer,
  ThemeMode: ThemeModeReducer,
  chat: chatSliceReducer,

  // ////// User Authorized api call
  [UserAuthorizedApi.reducerPath]: UserAuthorizedApi.reducer,

  // ////// User  api call
  [UserAuthApi.reducerPath]: UserAuthApi.reducer,
  [ChatApi.reducerPath]: ChatApi.reducer,


});

export const AllMiddleware = [
  UserAuthorizedApi.middleware,
  UserAuthApi.middleware,
  ChatApi.middleware,
];

